import request from "../utils/request";


// pc端通过动态码获取项目草稿 /api/Porject/getCodeProjectCg
export function getCodeProjectCg(params) {
    return request({
        url: "/api/Porject/getCodeProjectCg",
        method: "get",
        params
    });
}

// 用户编辑项目 /api/Porject/saveProject
export function saveProject(data) {
    return request({
        url: "/api/Porject/saveProject",
        method: "post",
        data
    });
}

// 获取项目类型列表 /api/Canshu/getProjectTypeAll
export function getProjectTypeAll(params) {
    return request({
        url: "/api/Canshu/getProjectTypeAll",
        method: "get",
        params
    });
}

//是否单选
export function getProjectType(params) {
    return request({
        url: "/api/Canshu/getProjectType",
        method: "get",
        params
    });
}

//查询老师
export function getProjectTeacher(params) {
    return request({
        url: "/api/Porject/getProjectTeacher",
        method: "get",
        params
    });
}

//删除老师
export function delProjectTeacher(data) {
    return request({
        url: "/api/Porject/delProjectTeacher",
        method: "post",
        data
    });
}

//保存老师
export function saveProjectTeacher(data) {
    return request({
        url: "/api/Porject/saveProjectTeacher",
        method: "post",
        data
    });
}

// 添加项目预算 /api/Porject/saveProjectBudget
export function saveProjectBudget(data) {
    return request({
        url: "/api/Porject/saveProjectBudget",
        method: "post",
        data
    });
}

// 删除项目预算 /api/Porject/deleteProjectBudget
export function deleteProjectBudget(data) {
    return request({
        url: "/api/Porject/deleteProjectBudget",
        method: "post",
        data
    });
}

// 修改项目预算 /api/Porject/updateProjectBudget 
export function updateProjectBudget(data) {
    return request({
        url: "/api/Porject/updateProjectBudget",
        method: "post",
        data
    });
}

// 按照项目获取所有预算列表 /api/Porject/getProjectBudgetList
export function getProjectBudgetList(params) {
    return request({
        url: "/api/Porject/getProjectBudgetList",
        method: "get",
        params
    });
}

// 获取指定年份赛事详情 /api/Canshu/getMatchFind
export function getMatchFind(params) {
    return request({
        url: "/api/Canshu/getMatchFind",
        method: "get",
        params
    });
}

// 获取入围名单列表 /api/Porject/getRwProject
export function getRwProject(params) {
    return request({
        url: "/api/Porject/getRwProject",
        method: "get",
        params
    });
}

// 获取今年比赛获奖名单 /api/Porject/getProjectReward
export function getProjectReward(params) {
    return request({
        url: "/api/Porject/getProjectReward",
        method: "get",
        params
    });
}

// 查询团队项目成员 /api/Porject/getProjectMember  参数 project_id
export function getProjectMember(params) {
    return request({
        url: "/api/Porject/getProjectMember",
        method: "get",
        params
    });
}
// 保存项目团队成员 /saveProjectMmeber  post
export function saveProjectMmeber(data) {
    return request({
        url: "/api/Porject/saveProjectMmeber",
        method: "post",
        data
    });
}
// 删除项目团队成员：/api/Porject/delProjectMember
export function delProjectMember(data) {
    return request({
        url: "/api/Porject/delProjectMember",
        method: "post",
        data
    });
}

// 获取赛事列表
export function getMatchAll(){
    return request({
        url: '/api/Canshu/getMatchAll',
        method: 'get'
    })
}

//登录 
export function loginbyweb(data) {
    return request({
        url: "/api/user/loginbyweb",
        method: "post",
        data
    });
}

//获得字段列表
export function getptip(){
    return request({
        url: '/api/Porject/getptip',
        method: 'get'
    })
}

//发送验证码 
export function send(params){
    return request({
        url: '/api/sms/send',
        method: 'get',
        params
    })
}
//项目评审登录 
export function AdminLogin(data) {
    return request({
        url: "/api/Adminapi/AdminLogin",
        method: "post",
        data
    });
}
//项目评审列表
export function getAdminProjectList(params){
    return request({
        url: '/api/Adminapi/getAdminProjectList',
        method: 'get',
        params
    })
}
//项目详情 
export function getProjectFind(params){
    return request({
        url: '/api/Porject/getProjectFind',
        method: 'get',
        params
    })
}
//选择意见 /api/Canshu/yijian
export function yijian(data) {
    return request({
        url: "/api/Canshu/yijian",
        method: "post",
        data
    });
}
//审核项目 
export function updateAdminProject(data) {
    return request({
        url: "/api/Adminapi/updateAdminProject",
        method: "post",
        data
    });
}

//手机号注册 
export function register(data) {
    return request({
        url: "/api/user/register",
        method: "post",
        data
    });
}
//检测手机验证码
export function checkSmsCorrect(params){
    return request({
        url: '/api/validate/check_sms_correct',
        method: 'get',
        params
    })
}
//发送验证码
export function sendSms(data) {
    return request({
        url: "/api/sms/send",
        method: "post",
        data
    });
}
//获得项目 
export function getCheckUserProject(params){
    return request({
        url: '/api/Porject/getCheckUserProject',
        method: 'get',
        params
    })
}
//项目列表 
export function getUserProjectList(params){
    return request({
        url: '/api/Porject/getUserProjectList',
        method: 'get',
        params
    })
}
//修改个人信息 
export function updateUser(data) {
    return request({
        url: "/api/User/updateUser",
        method: "post",
        data
    });
}
//更新手机号 
export function updateMobile(data) {
	return request({
		url: '/api/User/updateMobile',
		method:"post",
		data
	})
}
//修改密码 
export function changePwd(data) {
	return request({
		url: '/api/User/changePwd',
		method:"post",
		data
	})
}
////生成表格
export function imporExcel(data) {
	return request({
		url: '/api/Porject/imporExcel',
		method:"post",
		data
	})
}

//获得我的创建的团队
export function getMyCreateTeam(params){
    return request({
        url: '/api/Search/queryUserFTeam',
        method: 'get',
        params
    })
}